import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

interface JobPosition {
  id: string;
  type: string;
  title: string;
  description: string;
}

const CareersPositionsSection: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const positions: JobPosition[] = [
    {
      id: '1',
      type: 'Full time/ Remote',
      title: 'Business Analyst',
      description: 'Officia eu officia aliqua occaecat qui sunt excepteur laborum reprehenderit consectetur eu nulla labore pariatur. Et reprehenderit culpa incididunt'
    },
    {
      id: '2',
      type: 'Full time/ Remote',
      title: 'Brand Manager',
      description: 'Nostrud velit quis elit laborum occaecat qui aliqua sit ipsum dolor dolor ea anim veniam culpa consectetur. Excepteur laboris officia quis laboru'
    },
    {
      id: '3',
      type: 'Full time/ Remote',
      title: 'Senior Backend Developer',
      description: 'Noccaecat qui sunt excepteur laborum reprehenderit consectetur eu nulladolor ea anim veniam culpa consectetur. Excepteur laboris officia quis laboru'
    },
    {
      id: '4',
      type: 'Full time/ Remote',
      title: 'Business Analyst',
      description: 'Officia eu officia aliqua occaecat qui sunt excepteur laborum reprehenderit consectetur eu nulla labore pariatur. Et reprehenderit culpa incididunt'
    }
  ];

  const filteredPositions = positions.filter(position =>
    position.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    position.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleApply = () => {
    navigate('/contact');
  };

  return (
    <section id="open-positions" className="relative bg-white py-16 lg:py-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header and Search */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-16">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-open-sans font-bold text-[52px] leading-[74px] text-[#323743] mb-6 lg:mb-0"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            Open positions
          </motion.h2>

          {/* Search Input */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
            style={{ width: '319px' }}
          >
            <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
              <Search className="w-5 h-5 text-[#bdc1ca]" />
            </div>
            <input
              type="text"
              placeholder="Type positions"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-12 pr-4 py-2.5 border border-[#bdc1ca] rounded-[20px] font-manrope font-normal text-[16px] leading-[26px] text-[#bdc1ca] placeholder:text-[#bdc1ca] focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-brand-yellow"
              style={{ height: '43px' }}
            />
          </motion.div>
        </div>

        {/* Job Listings */}
        <div className="space-y-0">
          {filteredPositions.map((position, index) => (
            <motion.div
              key={position.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between py-6 border-b border-[#bdc1ca]">
                <div className="flex-1 mb-4 lg:mb-0">
                  {/* Type Badge */}
                  <p className="font-manrope font-normal text-[14px] leading-[22px] text-[#ffad0a] mb-2">
                    {position.type}
                  </p>

                  {/* Title */}
                  <h3 className="font-open-sans font-semibold text-[24px] leading-[36px] text-[#323743] mb-3" style={{ fontVariationSettings: "'wdth' 100" }}>
                    {position.title}
                  </h3>

                  {/* Description */}
                  <p className="font-manrope font-normal text-[16px] leading-[26px] text-[#171a1f] mb-2">
                    {position.description}{' '}
                    <a
                      href="#"
                      className="text-[#379ae6] underline text-[14px] leading-[22px]"
                      onClick={(e) => {
                        e.preventDefault();
                        // Can open job description modal or navigate to detailed page
                      }}
                    >
                      Job Description
                    </a>
                  </p>
                </div>

                {/* Apply Button */}
                <div className="flex-shrink-0">
                  <button
                    onClick={handleApply}
                    className="bg-[#fff8eb] text-[#966400] font-manrope font-normal text-[18px] leading-[28px] px-6 py-3 rounded-lg hover:bg-[#ffedcc] transition-colors"
                    style={{ width: '125px', height: '52px' }}
                  >
                    Apply now
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {filteredPositions.length === 0 && (
          <div className="text-center py-12">
            <p className="font-manrope font-normal text-[16px] text-[#323743]">
              No positions found matching your search.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default CareersPositionsSection;
